export const noteTemp = {}